import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import tw from "twin.macro"

const Button = styled.button`
  ${tw`border-0 p-0 text-neutralLight flex items-center md:text-neutralLight z-20 h-10 rounded-lg cursor-pointer font-medium transition-all`}
  background-color: ${props => props.color};
  ${props =>
    props.reverse &&
    `background: transparent;
      border: 1px solid ${props.color};
      a{
        color: ${props.color};
      }

      @media (min-width: 768px) {
        background: ${props.color};
        border: 0;
      };
    `}

  & {
    a {
      ${tw`flex items-center text-neutralLight no-underline px-6 py-2 w-full h-full`}
    }
  }
`

const ButtonSecondary = ({ children, reverse, color }) => (
  <Button color={color} reverse={reverse}>
    {children}
  </Button>
)

ButtonSecondary.propTypes = {
  children: PropTypes.node.isRequired,
  reverse: PropTypes.bool,
  color: PropTypes.string.isRequired,
}

ButtonSecondary.defaultProps = {
  reverse: false,
}

export default ButtonSecondary
